import { toast } from "sonner";
import { LINKS } from "@/lib/site";

const notifySoon = () => toast("InkMaster arriva presto", { description: "La mia app per imparare a tatuare sta per uscire: lascia la tua email e ti avviso appena è online." });

const Badge = ({ href, icon, small, big, testid }) => {
  const cls = "group inline-flex h-14 items-center gap-3 border border-line bg-ink pl-4 pr-4 text-left transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-acid";
  const inner = (
    <>
      <i className={`${icon} text-2xl text-bone transition-colors group-hover:text-acid`} />
      <span className="leading-tight">
        <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-smoke">{small}</span>
        <span className="block font-display text-sm font-semibold text-bone">{big}</span>
      </span>
    </>
  );
  if (href) {
    return (
      <a href={href} target="_blank" rel="noreferrer" data-testid={testid} className={cls}>
        {inner}
      </a>
    );
  }
  return (
    <button type="button" onClick={notifySoon} data-testid={testid} className={cls}>
      {inner}
      <span className="ml-1 bg-acid/15 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-widest text-acid">Coming soon</span>
    </button>
  );
};

export const StoreBadges = ({ appStoreTestId, googlePlayTestId, className = "" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    <Badge href={LINKS.appStore} icon="fa-brands fa-apple" small="Scarica su" big="App Store" testid={appStoreTestId} />
    <Badge href={LINKS.googlePlay} icon="fa-brands fa-google-play" small="Disponibile su" big="Google Play" testid={googlePlayTestId} />
  </div>
);
